










































import { chunk } from '~/utils/array'
import { defineComponent } from '~/utils/nuxt3-migration'
import { PropType } from 'vue'
import { CategoryId } from '~/models/category/types'
import useClassifiedKeyFeatures from '~/compositions/useClassifiedKeyFeatures'
import { KeyFeature } from '~/models/classified/types'

export default defineComponent({
  props: {
    keyFeatures: {
      type: Array as PropType<KeyFeature[]>,
      required: true
    },
    cols: {
      type: Number,
      default: 4
    },
    sm: {
      type: Number,
      default: 4
    },
    md: {
      type: Number,
      default: 4
    },
    lg: {
      type: Number,
      default: 3
    },
    categoryIds: {
      type: Array as PropType<CategoryId[]>,
      default: () => []
    }
  },
  setup(props) {
    const { getKeyFeatureIcon } = useClassifiedKeyFeatures(props.categoryIds)

    return {
      getKeyFeatureIcon
    }
  },
  computed: {
    keyFeaturesColumns() {
      return chunk(this.keyFeatures, 3)
    }
  },
  methods: {
    normalizeValue(value: string) {
      if (value && value.match(/\S\/\S/gi)) {
        return value.replace(/\//g, ' / ')
      }
      return value
    }
  }
})
